import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { DataResult } from 'src/app/models/data-result.mode';
import { UserRegistration } from 'src/app/models/user-registration.model';
import { AuthService } from 'src/app/services/auth.service';
import { UserRegistrationService } from 'src/app/services/user-registration.service';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
  standalone: true,
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: [
    './user-registration.component.scss',
    '../../styles/portalmenu.common.scss',
    '../../styles/global-header.scss'
  ],
  imports: [ CommonModule ]
})

export class UserRegistrationComponent implements OnInit, OnDestroy {
  @Input() isUserLoggedIn: boolean;
  @Input() isFederationLoaded: boolean;
  @Input() userEmail: string;
  public showProductsMenu = false;
  public isSingleSignonClient = false;
  public enableNotifications = false;
  public showPgProducts = false;
  public singleSignonTitle = environment.SingleSignonTitle;
  public huddleBoardName = 'C&R Huddle Board';
  private ndnqiIdp: UserRegistration;
  public userRegistrations: UserRegistration[] = new Array<UserRegistration>();
  private $subscriptions: Subscription = new Subscription();
  selectedSubscriptionID: number;
  availableSubscriptions: string;


  constructor(public authService: AuthService,
              public userRegistrationService: UserRegistrationService,
              private logger: LoggingMessageService,
              private sanitizer: DomSanitizer,
              public route: Router,
              private subscriptionService: SubscriptionChangeService) {
                this.enableNotifications = environment.EnableNotifications;
              }


  public toggleProducts() {
    this.showPgProducts = !this.showPgProducts;
  }

  public switchProducts($product) {
    this.toggleProducts();
    this.windowForProduct($product);
  }

  public getTitle(reg: UserRegistration): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(reg.IdpTitle);
  }

  private windowForProduct(product: string) {
    let windowUrl = 'https://www.pressganey.com/products/clinical-excellence';
    const targetIdp = this.userRegistrations.find(ur => ur.IdpName === product);
    if (targetIdp) {
      if ((targetIdp.IsUserRegistered === true) && (targetIdp.AcsUrl)) {
        windowUrl = `${environment.GenerateSamlResponsePage}?acs=${targetIdp.AcsUrl}`;
      } else {
        windowUrl = targetIdp.idpProductUrl;
      }

      this.logger.info('different-domain', 'setWindowSource', this.selectedSubscriptionID, this.availableSubscriptions , `Href: ${windowUrl}`, '');
      window.open(windowUrl, targetIdp.IdpName);
    }
  }

  public ngOnInit(): void {
    this.selectedSubscriptionID =  this.subscriptionService.SelectedSubscription;
    this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
    if (this.isUserLoggedIn === true) {
      let clientid = '';
      const clientParts: string[] = this.userEmail.split('@');
      if (clientParts && (clientParts.length > 1)) {
        clientid = clientParts[1];
      }
      this.subscribeToUserRegistration(this.userEmail, clientid);
    }
  }

  private subscribeToUserRegistration(email: string, clientId: string) {
    this.showProductsMenu = false;
    const addSubscription = this.userRegistrationService.getUserRegistrations(email, clientId)
      .subscribe(registrations => {
         this.addUserRegistrations(registrations);
         // uncomment to re-enable products menu
         // this.showProductsMenu = true;
      });
    this.$subscriptions.add(addSubscription);
  }

  private addUserRegistrations(registrations: any) {
    const result = registrations as DataResult;
    if (result && result.Ok) {
      const identityProviders = result.Data;
      this.isSingleSignonClient = identityProviders.isSingleSignonClient;

      if (environment.EnableHuddleBoard) {
        this.addHuddleBoardLink(identityProviders);
      }

      identityProviders.registrations.forEach(idp => {
        const ur = new UserRegistration(idp.idpName, idp.idpTitle, idp.userEmail, idp.isUserRegistered, idp.idpDescription, idp.idpProductUrl, idp.acsUrl, idp.loginUrl);
        if (idp.idpName === 'NDNQI') {
          this.ndnqiIdp = ur;
        } else {
          this.userRegistrations.push(ur);
        }
      });
    }
  }

  private addHuddleBoardLink(identityProviders: any) {
    const registered = identityProviders.registrations.filter( idp => idp.isUserRegistered);
    if (registered && registered.length > 0) {
      const ur = new UserRegistration(environment.HuddleBoardName, environment.HuddleBoardTitle, null, true, environment.HuddleBoardDesc, '', environment.HuddleBoardUrl, '');
      this.userRegistrations.push(ur);
    }
  }

  unsubscribe() {
    if (this.$subscriptions) {
        this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
      this.unsubscribe();
  }

}
